var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',[_c('v-card-text',[_c('server-address',{attrs:{"type":"autocomplete"},on:{"trigger":(fn) => _vm.triggerFn=fn}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }